<template>
  <v-row class="section" :class="{'my-5': subsection, 'ma-5': !subsection, [color]: color, 'secondary': !color}">
    <v-col>
      <v-row>
        <v-col class="mx-5 mb-5 mt-3">
          <v-row>
            <v-col cols="12" sm="6" md="8">
              <h2 v-if="title" class="primary--text d-inline">{{ title }}</h2>
              <h4 v-if="subtitle" class="primary--text d-inline font-weight-light">{{ ' ' + subtitle }} </h4>
            </v-col>
            <v-col cols="6" sm="6" md="4" :align="$vuetify.breakpoint.smAndUp ? 'right' : 'left'">
              <slot name="aside"></slot>
            </v-col>
          </v-row>
          <slot name="body"></slot>
          <v-row>
            <v-expansion-panels v-if="otherOptions" flat>
              <v-expansion-panel :class="{[otherOptionsColor]: otherOptionsColor, 'tertiary': !otherOptionsColor}">
                <v-expansion-panel-header>
                  {{ $t('sections.other_options') }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <slot name="otherOptions"></slot>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="footerAddon" class="primary footer-addon pointer"
        @click="$emit('footerAddonClick')">
        <slot name="footerAddon"></slot>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    otherOptions: Boolean,
    otherOptionsColor: String,
    footerAddon: Boolean,
    color: String,
    subsection: Boolean
  }
}
</script>

<style lang="scss" scoped>
.section {
  border-radius: 5px;
}
.footer-addon {
  border-radius: 0px 0px 5px 5px;
}
</style>
